import React from 'react';
import { Row, Col, Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import Icon from '../../common/containers/icon';
import TextInput from '../../common/controls/textInput';
import { removeItemWithConfirm } from '../../common/classes/handleItemWithConfirm';
const JobComponentCodeItem = props => {
  const {
    data,
    index,
    onRemove: propsOnRemove,
    onChange,
    data: {
      name: propsDataName
    }
  } = props;
  const onRemove = () => propsOnRemove(index);
  const handleRemove = () => removeItemWithConfirm(data, 'component code', ['name'], onRemove);
  const handleChange = (name, value) => onChange(index, {
    name,
    value
  });
  const classContainer = `t-jcc-${kebabCase(propsDataName)} t-jcc-${kebabCase(index)}`;
  return /*#__PURE__*/React.createElement("section", {
    className: classContainer
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: 9
  }, /*#__PURE__*/React.createElement(TextInput, {
    data: data,
    entity: "JobComponentCode",
    field: "name",
    focus: true,
    hideLabel: true,
    onChange: handleChange,
    placeholder: "Enter Component Code Name"
  })), /*#__PURE__*/React.createElement(Col, {
    sm: 3
  }, /*#__PURE__*/React.createElement(Button, {
    size: "sm",
    onClick: handleRemove,
    className: "form-control t-jcc-remove-component-code tqc-control"
  }, /*#__PURE__*/React.createElement(Icon, {
    glyph: "trash"
  }), " Remove Component"))));
};
JobComponentCodeItem.propTypes = {
  index: PropTypes.number.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string
  }).isRequired,
  onRemove: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired
};
export default JobComponentCodeItem;